import React from 'react';
import styles from './modal.module.scss';

const Modal = ({ children, isOpen, onClose}) => {
  return (
    <div className={`${styles.overlay} ${isOpen ? styles.active : null}`}>
      <button className={styles.close} onClick={() => onClose()}>
        <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.55134 36.4138L4.5192 35.6938L23.3345 16.8785L20.5061 14.0501L7.24 27.3162L6.88613 28.0028L1.85716 33.0318L0.388216 34.9444L2.47363 35.3824L2.55134 36.4138Z"/>
          <path d="M34.2182 1.58568L32.2503 2.30571L13.435 21.121L16.2634 23.9495L29.5295 10.6834L29.8834 9.99674L34.9124 4.96776L36.3813 3.05514L34.2959 2.61716L34.2182 1.58568Z"/>
          <path d="M34.603 36.4138L32.6351 35.6938L13.8198 16.8785L16.6482 14.0501L29.9143 27.3162L30.2682 28.0028L35.2971 33.0318L36.7661 34.9444L34.6807 35.3824L34.603 36.4138Z"/>
          <path d="M2.9361 1.58568L4.90397 2.30571L23.7193 21.121L20.8909 23.9495L7.62476 10.6834L7.2709 9.99674L2.24192 4.96776L0.772981 3.05514L2.85839 2.61716L2.9361 1.58568Z"/>
        </svg>
      </button>
      <div className={styles.wrapper}>
        { children }
      </div>
    </div>
  );
};

export default Modal;